import { render, staticRenderFns } from "./ExampleProjects.vue?vue&type=template&id=b99a55a6&scoped=true"
import script from "./ExampleProjects.vue?vue&type=script&lang=js"
export * from "./ExampleProjects.vue?vue&type=script&lang=js"
import style0 from "./ExampleProjects.vue?vue&type=style&index=0&id=b99a55a6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99a55a6",
  null
  
)

export default component.exports